import { cn } from '@/shadcn-ui/utils';
import { ReactNode } from 'react';

interface SavingsCalculatorBlobContainerProps {
  className?: string;
  children: ReactNode;
}

export default function SavingsCalculatorBlobContainer({
  className,
  children,
}: SavingsCalculatorBlobContainerProps) {
  return (
    <div
      className={cn(
        'flex flex-col rounded-[24px] border-[1px] border-solid border-flexcar-neutral80 bg-flexcar-neutral100 bg-opacity-70 px-[16px] py-[24px] backdrop-blur-[22px]',
        className
      )}
    >
      {children}
    </div>
  );
}
